
import './Loader.scss';

interface Props {
    siteId: string;
}

export const Loader = ({siteId}: Props) => {
    return <div className={`loader`}>
        <h1>Loading</h1>
        <br/>

        { siteId &&
            <div id="logo">
                <img src={`https://wundra.de/static/assets/svg/site${siteId}-logo.svg`} />
            </div>
        }
        <div className="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
        </div>

    </div>
}